import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; // Ensure Bootstrap JS is included
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import "./carousel.css";

const CarouselExample = () => {
  useEffect(() => {
    // Get the carousel element and initialize the carousel
    const carouselElement = document.getElementById('carouselExampleRide');
    const carousel = new window.bootstrap.Carousel(carouselElement, {
      interval: 3000, // Auto-slide every 3 seconds
      ride: 'carousel', // Automatically start sliding
    });
    // Optional: You can also manually control the pause and play functionality
  }, []); // This effect will only run once when the component mounts

  return (
    <div id="carouselExampleRide" className="carousel slide" data-bs-ride="carousel">
      <div className="carousel-inner">
        <div className="carousel-item active" data-bs-interval="3000">
          <img
            src={`${process.env.PUBLIC_URL}/Assests/Competative_Banner.jpg`}
            className="d-block w-100"
            alt="First Slide"
          />
        </div>
        <div className="carousel-item" data-bs-interval="3000">
          <img
            src={`${process.env.PUBLIC_URL}/Assests/Additional_CoverPage.png`}
            className="d-block w-100"
            alt="Second Slide"
          />
        </div>
        <div className="carousel-item" data-bs-interval="3000">
          <img
            src={`${process.env.PUBLIC_URL}/Assests/CoverPage_2.png`}
            className="d-block w-100"
            alt="Third Slide"
          />
        </div>
      </div>

      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExampleRide"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>

      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#carouselExampleRide"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};

export default CarouselExample;
